<template>
  <div class="call-tab">
    <img src="/logo.png" :height="30" class="mb-6" />
    <v-sheet class="call-tab__box pa-6 text-center" rounded="lg">
      <template v-if="moved">
        <h2 class="mb-3">{{ $t('callTab.moved.title', {defaultValue: 'Continued in another tab'}) }}</h2>
        <p class="mb-6">
          {{ $t('callTab.moved.text', {defaultValue: 'The call was moved to another tab or window on this device. This page no longer uses the camera and microphone.'}) }}
        </p>
      </template>
      <template v-else>
        <h2 class="mb-3">{{ $t('callTab.elsewhere.title', {defaultValue: 'AIRe Link is already open'}) }}</h2>
        <p class="mb-6">
          {{ $t('callTab.elsewhere.text', {defaultValue: 'AIRe Link is open in another tab or window on this device. Only one of them can use the camera and microphone. Close the other one, or continue here.'}) }}
        </p>
      </template>
      <v-btn color="primary" @click="emit('useHere')">{{ $t('callTab.useHere', {defaultValue: 'Use here'}) }}</v-btn>
    </v-sheet>
  </div>
</template>

<script setup>
// Shown instead of the app while another client page of this browser has the call (useCallTab)
defineProps({moved: Boolean})
const emit = defineEmits(['useHere'])
</script>

<style lang="scss" scoped>
.call-tab {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.call-tab__box {
  max-width: 480px;
}
</style>
